import { ObjectType } from '../../types/objectType';
import FILTER_TYPES from './filterTypes';

/**
* Autocomplete Filter Types
* These are the filter types related to civil works filters
*/
const CIVIL_WORKS_FILTERS: string[] = Object.keys(FILTER_TYPES)
  .filter((key) => key.startsWith('civilWorks'));

export default CIVIL_WORKS_FILTERS;
